import { Action } from '@ngrx/store';
import { SearchformResponseModel } from '../../shared/models/searchform-response.model';

export const SET_SEARCHFORM: string = '[XENA] SET_SEARCHFORM';
export const SET_SEARCHFORM_SUCCESS: string = '[XENA] SET_SEARCHFORM_SUCCESS';
export const SET_SEARCHFORM_ERROR: string = '[XENA] SET_SEARCHFORM_ERROR';


export class SetSearchform implements Action {
	readonly type: string = SET_SEARCHFORM;
}

export class SetSearchformSuccess implements Action {
	readonly type: string = SET_SEARCHFORM_SUCCESS;

	constructor(public payload: SearchformResponseModel) {}
}

export class SetSearchformError implements Action {
	readonly type: string = SET_SEARCHFORM_ERROR;

	constructor(public message?: string) {}
}

export type All
	= SetSearchform
	| SetSearchformSuccess
	| SetSearchformError;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/actions/searchform.ts